<template>
  <v-sheet elevation="0" class="ma-2 px-2 h85" v-if="user">
    <v-row class="mb-5">
      <v-col>
        <BackBtn to="/users" />
      </v-col>
      <!-- <Title
        v-model="user.name"
        empty="Insert a User's Full name..."
        icon="account"
        editable
      />
      <v-spacer></v-spacer> -->
    </v-row>
    <v-row class="justify-center mt-2">
      <v-col md="10">
        <v-card class="ma-1 pa-1" elevation="4">
          <v-row class="ma-1">
            <v-col class="ma-1">
              <v-row class="mt-1">
                <v-col>
                  <h4><v-icon>mdi-cog-outline</v-icon> General:</h4>
                </v-col>
              </v-row>
              <v-row class="my-1">
                <v-col>
                  <v-row>
                    <v-col cols="auto">
                      <v-avatar>
                        <v-img
                          max-width="50"
                          v-if="user.avatar"
                          :src="user.avatar"
                        />
                        <v-img
                          v-else
                          max-width="50"
                          contain
                          src="../assets/pine3_icon.svg"
                        />
                      </v-avatar>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="user.name"
                        label="Full Name"
                        :autocomplete="'false'"
                        :rules="rules.text"
                        hide-details
                        @input="changes = true"
                        required
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-text-field
                    v-model="user.email"
                    label="Username/E-Mail"
                    type="search"
                    placeholder="Username/E-Mail"
                    :disabled="!fresh"
                    @input="checkEmail"
                    :error-messages="error.type == 'email' ? error.msg : null"
                    dense
                  >
                  </v-text-field>
                  <!-- <p
                    class="error--text text-center text-body-2 pa-0"
                    v-if="error.type == 'email'"
                  >
                    {{ error.msg }}
                  </p> -->
                </v-col>
              </v-row>
              <v-row class="my-1">
                <v-col>
                  <v-select
                    :items="roles"
                    label="Role"
                    v-model="user.role"
                    autocomplete="off"
                    :disabled="self || user.role < role"
                    hide-details
                    @change="changes = true"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col>
                  <v-combobox
                    v-if="role < roleType.ADMIN"
                    :items="groups"
                    label="Company/Group"
                    v-model="selectedGroup"
                    @keyup="search"
                    hide-details
                    clearable
                    multiple
                    :disabled="role > roleType.SUPER_ADMIN"
                    autocomplete="new-password"
                    @change="changes = true"
                    dense
                  >
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @mousedown.prevent
                        @click="toggleSelectAll"
                      >
                        <v-list-item-action>
                          <v-icon
                            :color="
                              selectedGroup.length > 0 ? 'indigo darken-4' : ''
                            "
                          >
                            {{ selectAllIcon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-combobox>
                  <v-text-field
                    v-else
                    :value="user.groupName"
                    label="Company/Group"
                    disabled
                    dense
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-divider vertical> </v-divider>
            <v-col class="ma-1">
              <v-row class="mt-1">
                <v-col cols="auto">
                  <v-switch
                    class="my-0"
                    :disabled="self"
                    color="success"
                    v-model="user.active"
                  >
                  </v-switch>
                </v-col>
                <v-col cols="auto">
                  <h4 class="my-1"><v-icon>mdi-power</v-icon> Active</h4>
                </v-col>
              </v-row>
              <v-row class="mt-1" v-if="!fresh">
                <v-col cols="auto">
                  <v-switch class="my-0" v-model="passwordToggle"> </v-switch>
                </v-col>
                <v-col cols="auto">
                  <h4 class="my-1">
                    <v-icon>mdi-form-textbox-password</v-icon>
                    Reset Password
                  </h4>
                </v-col>
              </v-row>
              <v-card
                class="pa-2"
                v-if="passwordToggle || fresh"
                :elevation="fresh ? '0' : '3'"
              >
                <v-card-subtitle class="pa-1">{{
                  fresh ? "Set Password" : "Reset Password"
                }}</v-card-subtitle>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="user.password"
                      label="Password"
                      :autocomplete="false"
                      :rules="rules.text && rules.pass"
                      :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="passShow ? 'text' : 'password'"
                      @click:append="passShow = !passShow"
                      hint="At least 8 characters & one letters or numbers"
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="password2"
                      label="Password Validation"
                      :rules="rules.text && rules.pass"
                      :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="passShow ? 'text' : 'password'"
                      @click:append="passShow = !passShow"
                      dense
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="!fresh">
                  <v-spacer> </v-spacer>
                  <v-col cols="auto">
                    <v-btn
                      class="ma-3"
                      :disabled="
                        !user.password ||
                        !user.password.length ||
                        password2 !== user.password
                      "
                      label="Save"
                      small
                      color="primary"
                      @click="updatePass"
                    >
                      <v-icon dark> mdi-content-save-move-outline </v-icon>
                      Update
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-row>
          <v-spacer> </v-spacer>
          <v-col cols="auto">
            <v-btn
              class="ma-3"
              :disabled="!valid"
              label="Save"
              color="success"
              @click="save"
            >
              <v-icon dark> mdi-content-save </v-icon> Save
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

import BackBtn from "../components/buttons/BackBtn.vue";
// import Title from "../components/Title.vue";
import { Group, RoleType, SelectItem, User } from "../types";
import { validations } from "../utils";

export default Vue.extend({
  name: "UserView",
  components: {
    BackBtn,
  },
  data() {
    return {
      rules: {
        text: [validations.empty],
        email: [validations.email],
        pass: [validations.password.len, validations.password.strength],
      },
      roleType: RoleType,
      changes: false,
      fresh: true,
      password2: "",
      passShow: false,
      passwordToggle: true,
      error: { type: "", msg: "" },
      groupsFilter: { limit: 1000, search: { name: "" } },
    };
  },
  props: {
    outerRoute: VueTypes.string,
  },
  computed: {
    valid(): boolean {
      const valid: boolean =
        (this.user?.name?.length > 0 &&
          this.user?.email?.length > 0 &&
          this.changes &&
          (this.fresh
            ? this.user.password &&
              this.user.password.length > 6 &&
              this.user.password === this.password2
            : true)) ||
        false;

      return valid;
    },
    self(): boolean {
      return this.$store.getters["Users/isSelf"];
    },
    role(): number {
      return this.$store.getters["Users/getRole"];
    },
    roles(): SelectItem[] {
      const roles = this.$store.getters.getRoles;
      return roles.filter((role: SelectItem) => role.value >= this.role);
    },
    user(): User {
      const user: User = this.$store.getters["Users/getCurrentUser"];
      this.$store.commit(
        "setTitle",
        user._id ? `Edit '${user.name}'` : "Add New User"
      );
      return user;
    },
    selectedGroup: {
      get() {
        // let group = { text: this.user.groupName || "", value: this.user.group };
        // if (!this.changes && this.user.group) {
        //   group = ;
        // }
        return (
          this.user.groups?.map((group: { name: string; _id: string }) => {
            if (group._id)
              return {
                text: group.name || "",
                value: group._id,
              };
          }) || []
        );
      },
      set(val: [{ text: string; value: string }]) {
        this.user.groups = val.map((group: SelectItem) => {
          return {
            name: group.text,
            _id: group.value,
          };
        });
        this.changes = true;
      },
    },
    groups() {
      if (this.role > RoleType.SUPER_ADMIN) {
        return [];
      }
      const groups = this.$store.getters["Users/getGroups"];
      return groups.map((group: Group) => {
        return { text: group.name, value: group._id || group.id };
      });
    },
    allGroups() {
      return this.selectedGroup.length >= this.groups.length;
    },
    someGroups() {
      return this.selectedGroup.length > 0 && !this.allGroups;
    },
    selectAllIcon() {
      if (this.allGroups) return "mdi-close-box";
      if (this.someGroups) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    userChanged() {
      this.user.group = this.selectedGroup.value;
      this.user.groupName = this.selectedGroup.text;
      this.$store.commit("Users/setCurrentUser", this.user);
    },
    async save() {
      // this.user.group = this.selectedGroup.value;
      // const user = { ...this.user };
      // user.group = this.selectedGroup.value;
      // this.user.groups = this.selectedGroup.map((group: SelectItem) => {
      //   return {
      //     name: group.text,
      //     _id: group.value,
      //   };
      // });
      // user.groupName = this.selectedGroup.value;
      // this.user.groupName = this.selectedGroup.text;
      console.log(this.selectedGroup, this.user);

      const req = await this.$store.dispatch("Users/saveUser", this.user);
      if (req.error) {
        this.error = req.error;
      }
      this.$router.push(this.outerRoute || "/users");
    },
    async checkEmail() {
      this.changes = true;
      const { email } = this.user;
      if (validations.email(email) === true) {
        const resp = await this.$store.dispatch("Users/checkEmail", email);
        if (!resp?.success) {
          this.error = {
            type: "email",
            msg: "Username/e-mail is already in use",
          };
        } else {
          if (this.error.type == "email") {
            this.error = {
              type: "",
              msg: "",
            };
          }
        }
      } else {
        this.error = {
          type: "email",
          msg: "E-Mail Adrress not valid.",
        };
      }
      console.log(this.error);
    },
    fetchGroups() {
      this.$store.dispatch("Users/fetchGroups", this.groupsFilter);
    },
    updatePass() {
      this.$store.dispatch("Users/updatePassword", {
        id: this.user._id,
        password: this.user.password,
      });
      this.password2 = "";
      this.user.password = "";
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.allGroups) {
          this.selectedGroup = [];
        } else {
          this.selectedGroup = this.groups.slice();
        }
      });
    },
    // changeGroup(option: { text: string; value: string }) {
    //   if (option) {
    //     const { text, value } = option;
    //     this.user.groupName = text;
    //     this.user.group = value;
    //     this.changes = true;
    //     // this.$store.commit("Users/setCurrentUserGroup", {
    //     //   groupName: text,
    //     //   group: value,
    //     // });
    //   }
    // },
    search(e: Event) {
      const target = e.target as HTMLTextAreaElement;
      const text = target.value;
      // if (text) {
      this.groupsFilter.search.name = text;
      this.fetchGroups();
      // }
    },
  },
  watch: {
    passwordToggle(on: boolean) {
      if (on) {
        this.user.password = "";
      } else {
        delete this.user.password;
      }
    },
  },
  async mounted() {
    this.$store.commit("setGlobalLoader", true);
    this.fetchGroups();
    const { id } = this.$route.params;
    this.$store.commit("Users/setCurrentUser");
    if (id) {
      this.fresh = false;
      this.passwordToggle = false;
      await this.$store.dispatch("Users/fetchCurrentUser", id);
    }
    this.$store.commit("setGlobalLoader");
    // if (this.user.groups?.length) {
    //   this.selectedGroup = this.user.groups.map(
    //     (group: { name: string; _id: string }) => {
    //       return {
    //         text: group.name || "",
    //         value: group._id,
    //       };
    //     }
    //   );
    // }
  },
});
</script>
